import axios from "axios";
import * as Yup from "yup";
import { useCallback, useMemo } from "react";

export default function useFormCompany(data, setPage) {
  const setData = data[1];

  const checkEmailExists = useCallback(async (email, setFieldError) => {
    const res = await axios.get("user/exists/email/" + email);
    if (res.data?.exists) {
      setFieldError("companyEmail", "Email ya existe");
      return false;
    }
    return true;
  }, []);

  const formSubmit = useCallback(
    async (values, { setSubmitting, setFieldError }) => {
      setSubmitting(true);
      let continueForm = await checkEmailExists(
        values.companyEmail,
        setFieldError
      );
      if (!continueForm) return;

      setData((prev) => {
        return {
          ...prev,
          basicInfo: values,
        };
      });

      setPage((prev) => prev + 1);
      setSubmitting(false);
    },
    [setPage, setData, checkEmailExists]
  );

  const validations = useMemo(
    () =>
      Yup.object().shape({
        legalRepresentativeName: Yup.string().required("No puede estar vacio"), //
        companyName: Yup.string().required("No puede estar vacio"), //
        companyAddress: Yup.string().required("No puede estar vacio"), //
        companyEmail: Yup.string() //
          .required("No puede estar vacio")
          .email("Correo Invalido")
          .matches(/^\S+$/, "No se permiten espacios en blanco")
          .test(
            "lowercase",
            "Debe contener solo letras minúsculas",
            function (value) {
              // validate if email if in lowercase
              return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
            }
          ),
        companyPhone: Yup.number() //
          .integer("No puede tener decimales")
          .test(
            "test-name",
            "Ingrese un número de teléfono válido de 8 dígitos.",
            (value) => {
              return (
                !value ||
                (value &&
                  Number.isInteger(value) &&
                  value.toString().length >= 8 &&
                  value.toString().length <= 8)
              );
            }
          )
          .typeError(
            "No debe incluir caracteres especiales, como #@&%-/, ni caracteres alfabéticos [A-Z, a-z]."
          ),
        companyCellphone: Yup.number() //
          .integer("No puede tener decimales")
          .test(
            "test-name",
            "Ingrese un número de teléfono válido de 8 dígitos.",
            (value) => {
              return (
                !value ||
                (value &&
                  Number.isInteger(value) &&
                  value.toString().length >= 8 &&
                  value.toString().length <= 8)
              );
            }
          )
          .typeError(
            "No debe incluir caracteres especiales, como #@&%-/, ni caracteres alfabéticos [A-Z, a-z]."
          ),
      }),
    []
  );

  return {
    checkEmailExists,
    formSubmit,
    validations
  }
}
